import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useArticleEditorPageRedirect = () => {
  return usePagesRedirect('useArticleEditorPageRedirect');
};
